import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useForm } from "react-hook-form";
import ProfilePicture from "../../Presentational/Person/ProfilePicture/ProfilePicture";
import ValidationService from "../../../Services/Shared/Validation.service";
import useService from "../../Hooks/useService";
import PersonService from "../../../Services/Person.service";
import { CancelButton, SaveButton } from "../StandardButtons/StandardButtons";
import { AlertError } from "../StandardAlerts/StandardAlerts";
import useUniqueId from "../../Hooks/useUniqueId";
const CommentBox = (props) => {
    const [me, loadMe] = useService(PersonService.me);
    React.useEffect(() => {
        loadMe();
    }, [loadMe]);
    const [makeCommentState, makeComment] = useService(props.onMakeComment);
    const { register, errors, handleSubmit, reset } = useForm();
    // @ts-expect-error - TS7031 - Binding element 'commentBody' implicitly has an 'any' type.
    const submit = ({ commentBody }) => {
        makeComment(commentBody).then(() => {
            reset();
        });
    };
    const makeId = useUniqueId()[1];
    return (_jsxs("div", { className: "media" + (props.className || ""), children: [me.data && (_jsx(ProfilePicture, { person: me.data, showProfilePicture: true, size: 40, className: "mr-2" })), _jsxs("form", { onSubmit: handleSubmit(submit), className: "media-body", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { className: "sr-only", htmlFor: makeId("comment-box"), children: "Comment" }), _jsx("textarea", { id: makeId("comment-box"), className: ValidationService.makeClassName(errors, "commentBody", "form-control"), ref: register({ required: "Comment is required" }), 
                                /* eslint-disable-next-line jsx-a11y/no-autofocus */
                                autoFocus: true, name: "commentBody", autoComplete: "off" }), _jsx("div", { className: "invalid-feedback", children: "Please enter a comment" })] }), makeCommentState.hasError && (_jsx(AlertError, { message: "There was an error saving your comment", detail: makeCommentState.errorMessage })), _jsxs("div", { className: "d-flex justify-content-end", children: [_jsx(SaveButton, { isLoading: makeCommentState.isLoading, type: "submit", className: "mr-2" }), _jsx(CancelButton, { disabled: makeCommentState.isLoading, onClick: () => {
                                    reset();
                                    props.onCancel();
                                } })] })] })] }));
};
export default CommentBox;
